module.exports = __webpack_public_path__ + "media/images/expert__lutz-pfannenstiel-2cedb78dd452d950ac415571accce1c7.png";